import { API } from "./api";

export const getOwnerProfile = (ownerId) => API.get(`/owners/${ownerId}`);
export const getAllOwners = () => API.get(`/owners`);
export const getOwnerById = (id) => API.get(`/owners/${id}`);
export const getScreensForOwner = (ownerId) =>
  API.get(`/owners/screens/${ownerId}`);
export const addOwner = (owner) => API.post(`/owners/admin`, owner);
export const deleteOwner = (ownerId) => API.delete(`/owners/${ownerId}`);

export const updateOwner = (id, owners) =>
  API.put(`owners/admin/${id}`, owners);
